(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tw-pdp-buy-buttons"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('.tw-pdp-buy-buttons__qty-input').forEach(function(qtyInput) {
      var form = qtyInput.closest('form');
      if (!form) return;
      var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
      var max = parseInt(qtyInput.getAttribute('max'), 10) || 99;
      var row = qtyInput.closest('.tw-pdp-buy-buttons__row');
      if (!row) return;
      row.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var n = parseInt(qtyInput.value, 10) || min;
          qtyInput.value = Math.max(min, n - 1);
        });
      });
      row.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var n = parseInt(qtyInput.value, 10) || min;
          qtyInput.value = Math.min(max, n + 1);
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-product-media"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
      var slides = gallery.querySelectorAll('.tw-gallery__slide');
      var thumbs = gallery.querySelectorAll('.tw-gallery__thumb');
      var dots = gallery.querySelectorAll('.tw-gallery__dot');
      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');
      var total = slides.length;
      if (total < 2) return;

      var current = 0;
      var animating = false;

      function goTo(index, direction) {
        if (animating || index === current || index < 0 || index >= total) return;
        animating = true;

        var oldSlide = slides[current];
        var newSlide = slides[index];

        var exitClass = direction === 'next' ? 'tw-gallery__slide--exit-left' : 'tw-gallery__slide--exit-right';
        var enterFrom = direction === 'next' ? 'tw-translate-x-full' : 'tw-gallery__slide--exit-left';

        newSlide.classList.remove('tw-translate-x-full', 'tw-opacity-0', 'tw-pointer-events-none', 'tw-gallery__slide--exit-left', 'tw-gallery__slide--exit-right');
        if (direction === 'next') {
          newSlide.style.transform = 'translateX(100%)';
        } else {
          newSlide.style.transform = 'translateX(-100%)';
        }
        newSlide.style.opacity = '0';

        void newSlide.offsetWidth;

        newSlide.style.transform = '';
        newSlide.style.opacity = '';
        newSlide.classList.add('tw-gallery__slide--active');
        newSlide.setAttribute('aria-hidden', 'false');

        oldSlide.classList.remove('tw-gallery__slide--active');
        oldSlide.classList.add(exitClass);
        oldSlide.setAttribute('aria-hidden', 'true');

        setTimeout(function() {
          oldSlide.classList.remove(exitClass);
          oldSlide.classList.add('tw-translate-x-full', 'tw-opacity-0', 'tw-pointer-events-none');
          animating = false;
        }, 320);

        thumbs.forEach(function(t, i) {
          var isActive = i === index;
          t.classList.toggle('tw-border-gray-900', isActive);
          t.classList.toggle('tw-border-transparent', !isActive);
          t.setAttribute('data-active', isActive ? 'true' : 'false');
          if (isActive) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        });

        dots.forEach(function(d, i) {
          d.classList.toggle('tw-gallery__dot--active', i === index);
        });

        current = index;
      }
      
      gallery.goToSlide = function(index) {
        if (index === current || index < 0 || index >= total) return;
        goTo(index, index > current ? 'next' : 'prev');
      };

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current <= 0 ? total - 1 : current - 1, 'prev'); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current >= total - 1 ? 0 : current + 1, 'next'); });

      thumbs.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var idx = parseInt(btn.getAttribute('data-thumb-index'), 10);
          goTo(idx, idx > current ? 'next' : 'prev');
        });
      });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
          goTo(idx, idx > current ? 'next' : 'prev');
        });
      });

      var thumbWrap = gallery.querySelector('.tw-gallery__thumbs-wrap');
      if (thumbWrap) {
        var thumbsContainer = thumbWrap.querySelector('.tw-gallery__thumbs');
        var btnUp = thumbWrap.querySelector('.tw-gallery__thumb-arrow--up');
        var btnDown = thumbWrap.querySelector('.tw-gallery__thumb-arrow--down');
        var btnLeft = thumbWrap.querySelector('.tw-gallery__thumb-arrow--left');
        var btnRight = thumbWrap.querySelector('.tw-gallery__thumb-arrow--right');

        var scrollAmount = 140; // Roughly 2 thumbnails

        if (btnUp) btnUp.addEventListener('click', function() { thumbsContainer.scrollBy({ top: -scrollAmount, behavior: 'smooth' }); });
        if (btnDown) btnDown.addEventListener('click', function() { thumbsContainer.scrollBy({ top: scrollAmount, behavior: 'smooth' }); });
        if (btnLeft) btnLeft.addEventListener('click', function() { thumbsContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' }); });
        if (btnRight) btnRight.addEventListener('click', function() { thumbsContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' }); });
      }


      var startX = 0;
      var deltaX = 0;
      var swiping = false;
      var viewport = gallery.querySelector('.tw-gallery__viewport');
      if (viewport) {
        viewport.addEventListener('touchstart', function(e) {
          startX = e.touches[0].clientX;
          swiping = true;
        }, { passive: true });
        viewport.addEventListener('touchmove', function(e) {
          if (!swiping) return;
          deltaX = e.touches[0].clientX - startX;
        }, { passive: true });
        viewport.addEventListener('touchend', function() {
          if (!swiping) return;
          swiping = false;
          if (Math.abs(deltaX) > 40) {
            if (deltaX < 0) goTo(current >= total - 1 ? 0 : current + 1, 'next');
            else goTo(current <= 0 ? total - 1 : current - 1, 'prev');
          }
          deltaX = 0;
        });
      }

      gallery.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') goTo(current <= 0 ? total - 1 : current - 1, 'prev');
        if (e.key === 'ArrowRight') goTo(current >= total - 1 ? 0 : current + 1, 'next');
      });

      /* ── Lightbox ── */
      var lightbox = gallery.querySelector('[data-lightbox]');
      if (!lightbox) return;

      var lbItems = lightbox.querySelectorAll('[data-lightbox-item]');
      var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-lightbox-next]');
      var lbCounter = lightbox.querySelector('[data-lightbox-counter]');
      var lbTotal = lbItems.length;
      var lbCurrent = 0;

      function lbUpdateCounter() {
        if (lbCounter) lbCounter.textContent = (lbCurrent + 1) + ' / ' + lbTotal;
      }

      function lbShow(idx) {
        lbItems.forEach(function(item, i) {
          var img = item.querySelector('[data-lightbox-img]');
          if (img) {
            img.classList.remove('tw-lightbox__img--zoomed');
            img.style.transformOrigin = 'center center';
          }
          item.classList.toggle('tw-lightbox__item--active', i === idx);
        });
        lbCurrent = idx;
        lbUpdateCounter();
      }

      function lbOpen(idx) {
        lbShow(idx);
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function lbClose() {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      var viewport = gallery.querySelector('.tw-gallery__viewport');
      if (viewport) {
        viewport.addEventListener('click', function(e) {
          if (e.target.closest('[data-gallery-prev]') || e.target.closest('[data-gallery-next]')) return;
          lbOpen(current);
        });
      }

      lightbox.querySelectorAll('[data-lightbox-close]').forEach(function(btn) {
        btn.addEventListener('click', lbClose);
      });

      if (lbPrev) lbPrev.addEventListener('click', function() {
        lbShow(lbCurrent <= 0 ? lbTotal - 1 : lbCurrent - 1);
      });
      if (lbNext) lbNext.addEventListener('click', function() {
        lbShow(lbCurrent >= lbTotal - 1 ? 0 : lbCurrent + 1);
      });

      lbItems.forEach(function(item) {
        var img = item.querySelector('[data-lightbox-img]');
        if (!img) return;

        img.addEventListener('click', function(e) {
          e.stopPropagation();
          var isZoomed = img.classList.contains('tw-lightbox__img--zoomed');
          if (isZoomed) {
            img.classList.remove('tw-lightbox__img--zoomed');
            img.style.transformOrigin = 'center center';
          } else {
            var rect = img.getBoundingClientRect();
            var x = ((e.clientX - rect.left) / rect.width) * 100;
            var y = ((e.clientY - rect.top) / rect.height) * 100;
            img.style.transformOrigin = x + '% ' + y + '%';
            img.classList.add('tw-lightbox__img--zoomed');
          }
        });

        img.addEventListener('mousemove', function(e) {
          if (!img.classList.contains('tw-lightbox__img--zoomed')) return;
          var rect = item.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
        });
      });

      var lbSwipeX = 0;
      var lbSwipeDx = 0;
      var lbSwiping = false;
      var lbStage = lightbox.querySelector('[data-lightbox-stage]');
      if (lbStage) {
        lbStage.addEventListener('touchstart', function(e) {
          lbSwipeX = e.touches[0].clientX;
          lbSwiping = true;
        }, { passive: true });
        lbStage.addEventListener('touchmove', function(e) {
          if (!lbSwiping) return;
          lbSwipeDx = e.touches[0].clientX - lbSwipeX;
        }, { passive: true });
        lbStage.addEventListener('touchend', function() {
          if (!lbSwiping) return;
          lbSwiping = false;
          if (Math.abs(lbSwipeDx) > 50) {
            if (lbSwipeDx < 0) lbShow(lbCurrent >= lbTotal - 1 ? 0 : lbCurrent + 1);
            else lbShow(lbCurrent <= 0 ? lbTotal - 1 : lbCurrent - 1);
          }
          lbSwipeDx = 0;
        });
      }

      document.addEventListener('keydown', function(e) {
        if (lightbox.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape') lbClose();
        if (e.key === 'ArrowLeft') lbShow(lbCurrent <= 0 ? lbTotal - 1 : lbCurrent - 1);
        if (e.key === 'ArrowRight') lbShow(lbCurrent >= lbTotal - 1 ? 0 : lbCurrent + 1);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-search-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    var overlay = document.getElementById('tw-search-overlay');
    var popup = document.getElementById('tw-search-popup');
    var input = document.getElementById('tw-search-input');
    var loading = document.querySelector('[data-tw-search-loading]');
    var resultsBox = document.querySelector('[data-tw-search-results]');
    var keywordsBox = document.querySelector('[data-tw-search-keywords]');
    var popularBox = document.querySelector('[data-tw-search-popular]');
    var openBtns = document.querySelectorAll('[data-tw-open-search]');
    var closeBtn = document.querySelector('[data-tw-search-close]');

    var debounceTimer = null;
    var predictiveUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'search/suggest'
      : '/search/suggest';

    function open() {
      if (overlay) overlay.classList.add('is-open');
      if (popup) popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (input) { input.focus(); input.value = ''; }
      showDefaultContent();
    }

    function close() {
      if (overlay) overlay.classList.remove('is-open');
      if (popup) popup.classList.remove('is-open');
      document.body.style.overflow = '';
      if (input) input.value = '';
      showDefaultContent();
    }

    function showDefaultContent() {
      if (resultsBox) { resultsBox.style.display = 'none'; resultsBox.innerHTML = ''; }
      if (keywordsBox) keywordsBox.style.display = '';
      if (popularBox) popularBox.style.display = '';
    }

    function showResults(html) {
      if (keywordsBox) keywordsBox.style.display = 'none';
      if (popularBox) popularBox.style.display = 'none';
      if (resultsBox) { resultsBox.style.display = ''; resultsBox.innerHTML = html; }
    }

    function setLoading(on) {
      if (loading) loading.classList.toggle('is-loading', on);
    }

    function fetchPredictive(query) {
      if (!query || query.length < 2) {
        showDefaultContent();
        return;
      }

      setLoading(true);

      var url = predictiveUrl
        + '?q=' + encodeURIComponent(query)
        + '&resources[type]=product,query,page,article,collection'
        + '&resources[limit]=5'
        + '&section_id=tw-search-predictive-grid';

      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(text) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(text, 'text/html');
          var sectionContent = doc.querySelector('#shopify-section-tw-search-predictive-grid');
          if (sectionContent) {
            showResults(sectionContent.innerHTML);
          }
          setLoading(false);
        })
        .catch(function() {
          setLoading(false);
        });
    }

    openBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) { e.preventDefault(); open(); });
    });
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup && popup.classList.contains('is-open')) close();
    });

    if (input) {
      input.addEventListener('input', function() {
        var q = this.value.trim();
        clearTimeout(debounceTimer);
        if (q.length < 2) {
          showDefaultContent();
          setLoading(false);
          return;
        }
        debounceTimer = setTimeout(function() { fetchPredictive(q); }, 300);
      });
    }

    var kwPills = document.querySelectorAll('[data-tw-search-keyword]');
    kwPills.forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        var kw = this.getAttribute('data-tw-search-keyword');
        if (input) input.value = kw;
        fetchPredictive(kw);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-size-guide-modal"] && !Shopify.designMode) return;
  try {
    (function() {
    const modal = document.getElementById('tw-size-guide-modal');
    if (!modal) return;
    const body = modal.querySelector('.tw-size-guide-body');
    const overlay = modal.querySelector('.tw-size-guide-overlay');

    function open(contentId) {
      const source = contentId ? document.getElementById(contentId) : null;
      if (source) {
        const inner = source.querySelector('.tw-size-guide-content__inner');
        body.innerHTML = inner ? inner.innerHTML : source.innerHTML;
      } else {
        body.innerHTML = '';
      }
      modal.classList.remove('tw-hidden');
      modal.classList.add('tw-flex');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      modal.classList.add('tw-hidden');
      modal.classList.remove('tw-flex');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function(e) {
      const openBtn = e.target.closest('[data-tw-size-guide-open]');
      if (openBtn) {
        e.preventDefault();
        const contentId = openBtn.getAttribute('data-tw-size-guide-content');
        open(contentId);
      }
      if (e.target.closest('[data-tw-size-guide-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
